export const indexReceivablesQuery = ({ filters }) => ({
  url: `/recebivel`,
  method: "get",
  params: {
    ...filters,
  },
});
